export const NotFound = () => {
  return (
    <div>Not found 404</div>
  )
}